import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import TagDetail from '../components/tag/TagDetail';
import { SEO } from '../components/seo';

const TagDetailPage = ({ data, pageContext, location, locale }) => {
  return (
    <Layout locale={pageContext.locale} location={location}>
      <TagDetail data={data} />
    </Layout>
  );
};

export default TagDetailPage;

export const Head = ({ data }) => {
  return (
    <SEO title={data.tagsYaml.name} description={data.tagsYaml.description} />
  );
};

export const pageQuery = graphql`
  query TagDetailPage($uri: String!, $pk: String!, $language: String!) {
    site {
      siteMetadata {
        title
      }
    }
    locales: allLocale(
      filter: {
        ns: { in: ["common", "BlogTemplate", "TagDetail"] }
        language: { eq: $language }
      }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    allPeopleYaml(
      filter: {
        tags: { elemMatch: { pk: { eq: $pk } } }
        show_in_contacts: { eq: true }
      }
      sort: { priority: DESC }
    ) {
      nodes {
        name
        twitter
        linkedin
        role
        photo {
          publicURL
          name
        }
      }
    }
    tagsYaml(uri: { eq: $uri }, language: { eq: $language }) {
      name
      language
      description
      url
      url_pretty
      uri
      logo {
        childImageSharp {
          gatsbyImageData(layout: FIXED)
        }
      }
    }
    allMdx(
      sort: { frontmatter: { date: DESC } }
      filter: {
        frontmatter: {
          kind: { eq: "blog" }
          language: { eq: $language }
          publish: { eq: true }
          tags: { elemMatch: { pk: { glob: $pk } } }
        }
      }
    ) {
      edges {
        node {
          id
          excerpt(pruneLength: 90)
          frontmatter {
            uri
            title
            language
            kind
            tags {
              name
            }
            author {
              name
              role
              photo {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            date(formatString: "MMMM DD, YYYY")
            image {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
    allEventYaml(
      filter: {
        language: { eq: $language }
        project: { tags: { elemMatch: { pk: { glob: $pk } } } }
      }
      sort: { date: DESC }
    ) {
      nodes {
        id
        date(formatString: "YY-MM-DD")
        project {
          name
          language
          kind
          uri
          tags {
            name
            level
            language
            kind
          }
        }
        text
        gallery {
          image {
            childImageSharp {
              gatsbyImageData
            }
            publicURL
          }
        }
      }
    }
  }
`;
